/* CUSTOM JS */

/* Modifiated files : 
** - assets/custom.js
** - assets/css_header.scss
** - assets/css_collection.scss
** - layout/theme.liquid
** - sections/header.liquid
** - sections/main-cart.liquid
** - snippets/product-block.liquid
*/

(function () {
    /* Cart shipping cost computation on location */
    const priceSpan = $("#shipping_cost");
    if (priceSpan.length) {
        //geoip2.country(console.log, console.log)
        const cart = JSON.parse(document.getElementById("cartJson").innerHTML);
        const totalWeight = cart.total_weight;
        let shippingCost = 0;
        console.log("totalWeight:", totalWeight);

        function isUnder(nb) {
            return (totalWeight <= nb ? totalWeight : false);
        }

        if (navigator.languages.includes("fr-FR")) {
            console.log("Fr user");
            switch (totalWeight) {
                case isUnder(3):
                    shippingCost = 3.65;
                    break;
                case isUnder(20):
                    shippingCost = 4.75;
                    break;
                case isUnder(30):
                    shippingCost = 5.55;
                    break;
                case isUnder(40):
                    shippingCost = 5.90;
                    break;
                case isUnder(50):
                    shippingCost = 6.55;
                    break;
                case isUnder(500):
                    shippingCost = 6.95;
                    break;
                case isUnder(1000):
                    shippingCost = 7.55;
                    break;
                case isUnder(1250):
                    shippingCost = 8.95;
                    break;
                case isUnder(1500):
                    shippingCost = 10.45;
                    break;
                case isUnder(5000):
                    shippingCost = 10.95;
                    break;
                case isUnder(6000):
                    shippingCost = 11.95;
                    break;
                case isUnder(7000):
                    shippingCost = 12.95;
                    break;
                case isUnder(8000):
                    shippingCost = 13.95;
                    break;
                case isUnder(10000):
                    shippingCost = 15.60;
                    break;
                case isUnder(15000):
                    shippingCost = 19.30;
                    break;
                case isUnder(20000):
                    shippingCost = 20.80;
                    break;
                case isUnder(30000):
                    shippingCost = 25.80;
                    break;
                case isUnder(50000):
                    shippingCost = 31.00;
                    break;
                case isUnder(200000):
                    shippingCost = 39.00;
                    break;
                default:
                    shippingCost = 39.00;
                    break;
            }

            if (cart.total_price >= 20000) {
                shippingCost = 0;
            }
        } else {
            console.log("non Fr user");
            switch (totalWeight) {
                case isUnder(3):
                    shippingCost = 0;
                    break;
                case isUnder(500):
                    shippingCost = 13.77;
                    break;
                case isUnder(1000):
                    shippingCost = 15.00;
                    break;
                case isUnder(1250):
                    shippingCost = 16.00;
                    break;
                case isUnder(1500):
                    shippingCost = 18.00;
                    break;
                case isUnder(5000):
                    shippingCost = 22.00;
                    break;
                case isUnder(10000):
                    shippingCost = 26.00;
                    break;
                case isUnder(20000):
                    shippingCost = 35.00;
                    break;
                default:
                    shippingCost = 35.00;
                    break;
            }
        }

        priceSpan.text(`€${shippingCost.toLocaleString(undefined, { minimumFractionDigits: 2 })}`);
    }
})()